import { connect } from 'react-redux';
import BlockEditSidepanel from '../components/block/components/block-edit-sidepanel';
import {
  fetchBlockData,
  publishToSAP,
  markDateConfirmed,
  updateBlockData,
  addBlockData,
  deleteLaneData,
  fetchBlockDataSuccess,
  updateBlockId,
  setDateReference,
  splitBlock,
  deletePlanning,
  resetBlockData,
  markDateUnconfirmed,
  restoreBackup,
  recalculateTravelTime,
  openPlanningAndView,
} from './gantt-actions';

import {
  getLinkedPlanningsRequest,
} from '../../../order/details/containers/details-actions';

const mapStateToProps = state => ({
  block: state.gantt.block,
  isLoadingBlockData: state.gantt.isLoadingSidepanelBlockData,
  isDoingAction: state.gantt.isDoingAction,
  saveSuccess: state.gantt.saveSuccess,
  addSuccess: state.gantt.addSuccess,
  lanesInfo: state.gantt.lanesInfo,
  error: state.currentStatus.error,
});

const mapDispatchToProps = {
  fetchBlockData,
  publishToSAP,
  markDateConfirmed,
  splitBlock,
  updateBlockData,
  addBlockData,
  deleteLaneData,
  fetchBlockDataSuccess,
  updateBlockId,
  setDateReference,
  deletePlanning,
  resetBlockData,
  markDateUnconfirmed,
  restoreBackup,
  openPlanningAndView,
  getLinkedPlanningsRequest,
  recalculateTravelTime,
};

export default connect(mapStateToProps, mapDispatchToProps)(BlockEditSidepanel);
